<template>
    <!-- 底部尾部公用 -->
    <div class="mobile-bottom-footer">
        <div class="footer" v-if="flag">
            <div class="footer_top">
                <div class="containers">
                    <div class="footer_top_left">
                        <!-- <a href="../../index.html"> -->
                        <img class="logo_footer" src="../../assets/imgs/componentsPic/logo_footer.png" />
                        <!-- </a> -->
                        <div class="quick_url">
                            <span>快速通道：</span>
                            <router-link :to="{ path: '/comdedeauto' }">产品中心</router-link>
                            <router-link :to="{ path: '/solutionadmi' }">解决方案</router-link>
                            <router-link :to="{ path: '/companyNews' }">新闻动态</router-link>
                            <router-link :to="{ path: '/companyprofile' }">关于我们</router-link>
                            <router-link :to="{ path: '/jobmarket' }">职等你来</router-link>
                        </div>
                    </div>
                    <div class="footer_top_right">
                        <!-- 产品网站 -->
                        <div class="url_btn" @click="openList">
                            <span>产品网站</span>
                            <img class="urlIcon" :src="iconUrl" />
                        </div>
                        <ul class="product_url" v-show="isOpen">
                            <li><a href="https://www.dedeauto.com/#/" target="_blank">得得用车官网</a></li>
                            <!-- <li>万物理想官网</li> -->
                        </ul>
                    </div>
                </div>
            </div>
            <div class="footer_bottom containers">
                <div class="footer_bottom_left">
                    <div>
                        <div class="company_address">
                            <div>
                                <span class="company_name">[ 成都本部 ]</span>
                                <span class="company_name">[ 甘肃办事处 ]</span>
                            </div>
                            <div>
                                <span class="address">地址：成都市高新区天府五街999号1栋22层2205、2206号</span>
                                <span class="address">地址：兰州市七里河区兰州中心1幢2701室</span>
                            </div>
                            <div>
                                <span class="tel">电话：028-8339 8557</span>
                                <span class="tel">电话：0931-8339 8557</span>
                            </div>
                        </div>
                        <div class="put_records">
                            <span class="copyright">© Copyright 2021 Wideal.cn All Right Reserved.</span>
                            <span>
                                <a style="color: #777777" href="https://beian.miit.gov.cn/" target="_blank">
                                    蜀ICP备20001180号-1
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="footer_bottom_right">
                    <img class="gz_code" src="../../assets/imgs/componentsPic/QR_code.png" />
                    <p>关注公众号</p>
                </div>
            </div>
        </div>
        <div class="footer">
            <!--<div class="section-1 mobile-container">-->
            <!--&lt;!&ndash; 产品网站 &ndash;&gt;-->
            <!--<div class="url_btn" @click="openList"><span>产品网站</span><img class="urlIcon" :src="iconUrl"></div>-->
            <!--<ul class="product_url" v-show="isOpen">-->
            <!--<li><a href="https://www.dedeauto.com/#/" target="_blank">得得用车官网</a></li>-->
            <!--&lt;!&ndash; <li>万物理想官网</li> &ndash;&gt;-->
            <!--</ul>-->
            <!--</div>-->
            <div class="section-2">
                <div class="title">
                    <span>快速通道：</span>
                </div>
                <div class="router-box">
                    <router-link :to="{ path: '/comdedeauto' }">产品中心</router-link>
                    <router-link :to="{ path: '/solutionadmi' }">解决方案</router-link>
                    <router-link :to="{ path: '/companyNews' }">新闻动态</router-link>
                    <router-link :to="{ path: '/companyprofile' }">关于我们</router-link>
                    <router-link :to="{ path: '/jobmarket' }">职等你来</router-link>
                </div>
            </div>
            <div class="section-3 mobile-container">
                <img class="logo_footer" src="../../assets/imgs/componentsPic/logo_footer.png" />
            </div>
            <div class="section-4 mobile-container">
                <div class="address-out-box">
                    <span class="company_name">[ 成都本部 ]</span>
                    <span class="address-tel">
                        <span class="address">地址：成都市高新区天府五街999号1栋22层2205、2206号</span>
                        <span class="tel">电话：028-8339 8557</span>
                    </span>
                </div>
                <div class="address-out-box">
                    <span class="company_name">[ 甘肃办事处 ]</span>
                    <span class="address-tel">
                        <span class="address">地址：兰州市七里河区兰州中心1幢2701室</span>
                        <span class="tel">电话：0931-8339 8557</span>
                    </span>
                </div>
            </div>
            <div class="section-5">
                <img class="gz_code" src="../../assets/imgs/componentsPic/QR_code.png" />
                <p>关注公众号</p>
            </div>
            <div class="section-6 mobile-container">
                <span class="copyright">© Copyright 2021 Wideal.cn All Right Reserved.</span>
                <span>
                    <a style="display: inline-block;color: #777777" href="https://beian.miit.gov.cn/" target="_blank">
                        蜀ICP备20001180号-1
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            flag: false,
            iconUrl: require("../../assets/imgs/componentsPic/icon_urlOpen.png"),
            isOpen: false
        };
    },
    methods: {
        openList() {
            if (this.isOpen) {
                this.iconUrl = require("../../assets/imgs/componentsPic/icon_urlOpen.png");
                this.isOpen = false;
            } else {
                this.iconUrl = require("../../assets/imgs/componentsPic/icon_urlDown.png");
                this.isOpen = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
// @media screen and (max-width: 898px) {
//   .footer .quick_url {
//     width: 360px;
//   }
// }

// @media screen and (min-width: 898px) and (max-width: 1067px) {
//   .footer .quick_url {
//     width: 400px;
//   }
// }

// @media screen and (min-width: 1067px) {
//   .footer .quick_url {
//     width: 36vw;
//   }
// }
.mobile-bottom-footer {
    .mobile-container {
        width: 1778px;
        margin: 0 auto;
    }
    .footer {
        box-sizing: border-box;
        width: 100vw;
        // padding: 0 71.11px;
        background: #121213;
        .section-1 {
            position: relative;
            padding: 106.67px 0 104.89px;
            .url_btn {
                text-indent: 116px;
                box-sizing: border-box;
                width: 100%;
                border: 4px solid #2a2a2b;
                font-size: 64px;
                color: #d0d0d0;
                cursor: pointer;
                height: 284px;
                line-height: 284px;
            }

            .urlIcon {
                width: 44px;
                height: auto;
                position: absolute;
                right: 92.44px;
                top: 50%;
                transform: translateY(-50%);
            }

            .product_url {
                position: absolute;
                top: -294px;
                width: 100%;
                height: 284px;
                li {
                    height: 284px;
                    a {
                        text-indent: 116px;
                        -webkit-box-sizing: border-box;
                        box-sizing: border-box;
                        display: inline-block;
                        width: 100%;
                        height: 284px;
                        line-height: 284px;
                        color: #d0d0d0 !important;
                    }
                }
            }
        }
        .section-2 {
            font-size: 64px;
            color: #d0d0d0;
            padding: 106.67px 71.11px 107px;
            border-bottom: 4px solid #2a2a2b;
            .title {
                line-height: 142px;
            }
            .router-box {
                display: flex;
                justify-content: space-between;
                a {
                    color: #d0d0d0;
                    line-height: 142px;
                }
                a:hover {
                    color: #fff;
                }
            }
        }
        .section-3 {
            margin-top: 107px;
            margin-bottom: 100px;
            .logo_footer {
                height: 155.91px;
                width: auto;
            }
        }
        .section-4 {
            color: #777777;
            font-size: 57px;
            line-height: 85px;
            .address-out-box {
                display: flex;
                justify-content: flex-start;
                .company_name {
                    flex: 0 0 400px;
                    margin-right: 20px;
                }
                .address-tel {
                    display: flex;
                    flex-direction: column;
                }
            }
        }
        .section-5 {
            width: 571px;
            text-align: center;
            padding-top: 140px;
            box-sizing: border-box;
            margin-left: 71.11px;
            .gz_code {
                width: 571px;
                height: 571px;
                margin-bottom: 34px;
            }
            font-size: 57px;
            color: #d0d0d0;
        }
        .section-6 {
            margin: 139px 71.11px 132px;
            font-size: 57px;
            color: #777777;
            line-height: 85px;
        }
    }
}
</style>
